import { render, staticRenderFns } from "./BoCustomerBookingDatatable.vue?vue&type=template&id=1d4520ab&scoped=true"
import script from "./BoCustomerBookingDatatable.vue?vue&type=script&lang=js"
export * from "./BoCustomerBookingDatatable.vue?vue&type=script&lang=js"
import style0 from "./BoCustomerBookingDatatable.vue?vue&type=style&index=0&id=1d4520ab&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d4520ab",
  null
  
)

export default component.exports